import { IconName } from "components/SvgInline/types";
import { FC, ReactNode } from "react";
import { SvgInline } from "../SvgInline/SvgInline";
import styles from "./info-box.module.scss";

interface Props {
  children: ReactNode;
  iconName?: IconName;
  className?: string;
  grey?: boolean;
}

export const InfoBox: FC<Props> = ({
  children,
  iconName,
  className,
  grey = false,
}) => (
  <div
    className={`${styles.infoBlock} ${grey ? styles.grey : ""} ${className}`}
  >
    {iconName && (
      <SvgInline className={`${styles.infoBlockIcon}`} name={iconName} />
    )}
    <div className={styles.infoBlockText}>{children}</div>
  </div>
);
